<template>
  <div :class="className">
    <div class="sticky-select">
      <q-select
        label="Select vehicle"
        v-model="selectedVehicle"
        outlined
        label-color="grey-7"
        color="grey-7"
        :options="vehicles"
        :option-label="
          (vehicle) =>
            vehicle.unit && vehicle.brand && vehicle.brand.name
              ? `${vehicle.brand.name}#${vehicle.model.name}#${vehicle.unit}`
              : ''
        "
        :option-value="(vehicle) => vehicle.id"
        dense
      >
        <template v-slot:no-option>
          <q-item>
            <q-item-section class="text-italic text-grey">
              There is no options.
            </q-item-section>
          </q-item>
        </template>
      </q-select>
      <slot name="activator"></slot>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    className: String,
  },
  computed: {
    selectedVehicle: {
      get() {
        return this.$store.state.millage.selectedVehicle;
      },
      set(val) {
        this.$store.commit("millage/SET_SELECTED_VEHICLE", val);
      },
    },
    selectedMillage: {
      get() {
        return this.$store.state.millage.selectedMillage;
      },
      set(val) {
        this.$store.commit("millage/SET_SELECTED_MILLAGE", val);
      },
    },
    vehicles: {
      get() {
        return this.$store.state.millage.vehicles;
      },
      set(val) {
        this.$store.commit("millage/SET_VEHICLES", val);
      },
    },
  },
};
</script>
